import React, { FunctionComponent } from 'react';

import {
  HelfyAdvertRoot,
  TextSection,
  ImageSection,
  AdvertHeading,
  WebsiteLinkButton,
} from './HelfyAdvert.style';
import { Logo } from '../Logo';

const HelfyAdvert: FunctionComponent = () => (
  <HelfyAdvertRoot>
    <TextSection>
      <Logo kind="wordmark" width={140} title="Helfy" />
      <AdvertHeading>Check out what's cooking</AdvertHeading>
      <WebsiteLinkButton
        size="large"
        kind="primary"
        href="https://helfy.uk/menu"
      >
        Choose your meals
      </WebsiteLinkButton>
    </TextSection>
    <ImageSection
      href="https://helfy.uk/menu"
      aria-label="Helfy meals"
    />
  </HelfyAdvertRoot>
);

export default HelfyAdvert;
